import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  dayWrapper: {
    minWidth: Theme.typography.size[11],
    '&.wrapper-type-enabled': {
      backgroundColor: '#FFF',
    },
    '&.wrapper-type-disabled': {
      backgroundColor: '#FFF',
    },
    '&.wrapper-type-not-selectable': {
      cursor: 'not-allowed',
    },
    '&.wrapper-type-inRange': {
      backgroundColor: '#E1ECFA',
    },
    '&.wrapper-type-start': {
      background: 'linear-gradient(90deg, #FFF 50%, #E1ECFA 50%)',
    },
    '&.wrapper-type-end': {
      background: 'linear-gradient(-90deg, #FFF 50%, #E1ECFA 50%) !important',
    },
    [Theme.breakpoints.down(410)]: {
      minWidth: Theme.typography.pxToRem(35),
    },
  },
  dayButton: {
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[2],
    lineHeight: '150%',
    width: 50,
    height: 50,
    borderRadius: '50%',
    cursor: 'pointer',
    border: 0,
    padding: 0,
    outline: 'unset',
    '&.button-type-enabled': {
      backgroundColor: '#FFF',
      color: Theme.palette.primary.light,
    },
    '&.button-type-disabled': {
      backgroundColor: '#FFF',
      color: '#979797',
    },
    '&.button-type-not-selectable': {
      pointerEvents: 'none',
    },
    '&.button-type-inRange': {
      backgroundColor: '#E1ECFA',
      color: Theme.palette.primary.light,
    },
    '&.button-type-start': {
      backgroundColor: '#4D99FF',
      color: '#FFF',
    },
    '&.button-type-end': {
      backgroundColor: '#4D99FF',
      color: '#FFF',
    },
    [Theme.breakpoints.down('xs')]: {
      width: 48,
      height: 48,
    },
  },
  underscore: {
    width: 20,
    height: 3,
    background: Theme.palette.primary.main,
    borderRadius: '10px',
    margin: 'auto',
    [Theme.breakpoints.down(410)]: {
      width: 15,
      height: 3,
      margin: 'auto',
    },
  },
}));

export default useStyles;
